import { render, staticRenderFns } from "./change-info.vue?vue&type=template&id=3848451e&scoped=true&"
import script from "./change-info.vue?vue&type=script&lang=js&"
export * from "./change-info.vue?vue&type=script&lang=js&"
import style0 from "./change-info.vue?vue&type=style&index=0&id=3848451e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848451e",
  null
  
)

export default component.exports